module.exports = __webpack_public_path__ + "static/media/QuestionMarkCircle.f8271d76.svg";